import React, { useEffect } from 'react';
import { cache } from '../../graphql/cache';
import { client } from '../../index';
import { Redirect } from 'react-router-dom';

const LogoutPage = () => {
  useEffect(() => {
    cache.gc();
    client.resetStore();
    //client.cache.reset();
    localStorage.clear();
  }, []);

  return <Redirect to='/' />;
};

export default LogoutPage;
